/**
 * 60*60浮标 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 */
import { Vue, Component, Prop } from 'vue-property-decorator';
import AdvCommonContainer from '../adv-common-container';

import style from './index.module.scss';

@Component
export default class AdvProductListCornerMark extends Vue {
  /**
   * 广告位id
  */
  @Prop(String)
  private advMasterId!: string;

  private render() {
    return (
      <AdvCommonContainer
        advMasterId={this.advMasterId}
        customClassName={style.homeCornerMark}
      />
    );
  }
}
